import modal from '@motionelements/core/src/store/modules/modal.js';

export default {
  namespaced: true,
  state: () => modal.state,
  getters: modal.getters,
  actions: modal.actions,
  mutations: modal.mutations,
};
